// extracted by mini-css-extract-plugin
export default {"wrapper":"Page451_wrapper__-9iFx","title":"Page451_title__RNwV+","subtitle":"Page451_subtitle__ozvnz","exit":"Page451_exit__ibQty"};